import { FC, useMemo } from 'react'
import { Collapse, TableCell, TableRow } from '@mui/material'
import styled from 'styled-components'
import { PeopleAdminActions } from './PeopleAdminActions'
import { StripeAccountInfo } from './StripeAccountInfo'
import { ConnectedAccountsInfo } from './ConnectedAccountsInfo'
import { UserDetailsInfo } from './UserDetailsInfo'

import { spacingMD, spacingSM, FlexColumn } from 'Utils/styles/spacing'
import { UserStatus } from 'Utils/types/userStatus'

import { useEmployerUsersContext } from 'Contexts/EmployerUsersContext'

const Content = styled.div`
  padding: ${spacingMD};
`

const OuterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacingMD};
`

const LeftContainer = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  gap: ${spacingSM};
`

const FirstColumn = styled.div`
  min-width: 300px;
  max-width: 600px;
`

const SecondColumn = styled(FlexColumn)`
  flex: 1;
  min-width: 0;
  gap: ${spacingSM};
`

type PeopleDetailsRowProps = {
  open: boolean
  userId: number
  userStatus: UserStatus
  userPrograms: string[]
}
export const PeopleDetailsRow: FC<PeopleDetailsRowProps> = ({
  open,
  userId,
  userStatus,
  userPrograms
}) => {
  const {
    state: { users }
  } = useEmployerUsersContext()

  const user = useMemo(() => {
    return users.find((user) => user.id == userId)
  }, [users, userId])

  return (
    <TableRow
      style={{
        borderBottom: open ? '1px solid rgba(224, 224, 224, 1)' : 'none'
      }}
    >
      <TableCell
        style={{
          padding: 0,
          borderBottom: 'none'
        }}
        colSpan={10}
      >
        <Collapse in={open} timeout="auto" unmountOnExit>
          <Content>
            <OuterRow>
              <LeftContainer>
                <FirstColumn>
                  <UserDetailsInfo user={user} userPrograms={userPrograms} />
                </FirstColumn>
                <SecondColumn>
                  <StripeAccountInfo stripeAccountInfo={user?.stripeAccount} />
                  <ConnectedAccountsInfo userId={userId} />
                </SecondColumn>
              </LeftContainer>
              {user && (
                <PeopleAdminActions
                  userId={user.id}
                  userRoles={user.roles}
                  userStatus={userStatus}
                  hasStripeAccount={!!user.stripeAccount}
                  hasPurchaseAccount={user.hasPurchaseAccount}
                  userLocked={user.failedLoginCount >= 5}
                />
              )}
            </OuterRow>
          </Content>
        </Collapse>
      </TableCell>
    </TableRow>
  )
}
